/**
 * @generated SignedSource<<7ee656f5f3dde9e6af1d1fa47e5dc752>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Appropriateness = "APPROPRIATE" | "NOT_APPROPRIATE" | "NOT_EXPERIENCED" | "UNKNOWN";
export type AppropriatenessComplexProductsStatus = "APPROPRIATE" | "NOT_APPROPRIATE" | "UNKNOWN";
export type ComplianceStatus = "COMPLETED" | "FAILED" | "PENDING";
export type UserLanguage = "AR" | "DE" | "EN" | "ES" | "FR" | "IT" | "PL" | "TR";
export type UpdateUserInput = {
  aml?: ReadonlyArray<UserAML> | null | undefined;
  appropriateness?: ReadonlyArray<UserAppropriateness> | null | undefined;
  clientCategorization?: ReadonlyArray<UserClientCategorization> | null | undefined;
  complexProductsAppropriateness?: ReadonlyArray<UserComplexProductsAppropriateness> | null | undefined;
  cookiePreferences?: CookiePreferencesInput | null | undefined;
  dac8?: ReadonlyArray<UserDac8> | null | undefined;
  fatca?: ReadonlyArray<UserFatca> | null | undefined;
  isTaxEligible?: boolean | null | undefined;
  language?: UserLanguage | null | undefined;
  tax?: ReadonlyArray<UserTax> | null | undefined;
  termsAndConditions?: ReadonlyArray<string> | null | undefined;
};
export type UserAML = {
  answerId: string;
  questionId: string;
  value?: string | null | undefined;
};
export type UserAppropriateness = {
  answerId: string;
  questionId: string;
  value?: string | null | undefined;
};
export type UserFatca = {
  answerId: string;
  answerValue?: string | null | undefined;
  questionId: string;
};
export type UserDac8 = {
  answerId: string;
  answerValue?: string | null | undefined;
  countryCode: string;
  questionId: string;
};
export type UserClientCategorization = {
  answerId: string;
  answerValue?: string | null | undefined;
  questionId: string;
};
export type UserTax = {
  residenceCountry: string;
  tin: string;
};
export type CookiePreferencesInput = {
  marketing: boolean;
  performance: boolean;
};
export type UserComplexProductsAppropriateness = {
  answerId: string;
  questionId: string;
  value?: string | null | undefined;
};
export type UpdateUserMutation$variables = {
  input?: UpdateUserInput | null | undefined;
};
export type UpdateUserMutation$data = {
  readonly updateUser: {
    readonly accountLevelId?: string | null | undefined;
    readonly active?: boolean;
    readonly appropriateness?: Appropriateness | null | undefined;
    readonly appropriatenessComplexProducts?: {
      readonly requiresTestResubmission: boolean;
      readonly status: AppropriatenessComplexProductsStatus;
    } | null | undefined;
    readonly appropriatenessRequiresTestCompletion?: boolean | null | undefined;
    readonly appropriatenessRequiresTestResubmission?: boolean | null | undefined;
    readonly blacklisted?: boolean;
    readonly compliance?: {
      readonly clientCategorization: ComplianceStatus;
    } | null | undefined;
    readonly cookiePreferences: {
      readonly functional: boolean;
      readonly marketing: boolean;
      readonly performance: boolean;
    };
    readonly id: string;
    readonly language?: UserLanguage;
    readonly onboarded: boolean;
    readonly tradingActive?: boolean;
    readonly tradingDisabledReason?: string | null | undefined;
    readonly verificationReason?: string | null | undefined;
    readonly verificationStatus?: string;
    readonly verified?: boolean;
    readonly withdrawalsActive: boolean;
  } | null | undefined;
};
export type UpdateUserMutation = {
  response: UpdateUserMutation$data;
  variables: UpdateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboarded",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "withdrawalsActive",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CookiePreferences",
  "kind": "LinkedField",
  "name": "cookiePreferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "functional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "performance",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriateness",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestResubmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppropriatenessComplexProducts",
      "kind": "LinkedField",
      "name": "appropriatenessComplexProducts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresTestResubmission",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blacklisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountLevelId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingDisabledReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Compliance",
      "kind": "LinkedField",
      "name": "compliance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientCategorization",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IndividualUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "093274fd4ddf0f5bd0011ccfd090740b",
    "id": null,
    "metadata": {},
    "name": "UpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserMutation(\n  $input: UpdateUserInput\n) {\n  updateUser(input: $input) {\n    __typename\n    id\n    onboarded\n    withdrawalsActive\n    cookiePreferences {\n      marketing\n      functional\n      performance\n    }\n    ... on IndividualUser {\n      appropriateness\n      appropriatenessRequiresTestCompletion\n      appropriatenessRequiresTestResubmission\n      appropriatenessComplexProducts {\n        status\n        requiresTestResubmission\n      }\n      active\n      blacklisted\n      verified\n      verificationStatus\n      verificationReason\n      accountLevelId\n      tradingActive\n      tradingDisabledReason\n      language\n      compliance {\n        clientCategorization\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80e8c12eb6874cff30058db5dccf8bcd";

export default node;
